import React, { useState } from 'react';
import { Bath, Car, Coffee, Trees, UtensilsCrossed, Wifi } from 'lucide-react';
import { amenities, houseImages } from '../data/site';
import { Lightbox } from './Lightbox';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
const amenityIcons = {
  wifi: Wifi,
  coffee: Coffee,
  car: Car,
  utensils: UtensilsCrossed,
  towel: Bath,
  trees: Trees
};
export function House() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="house" className="w-full bg-ivory py-24 sm:py-28 lg:py-36" data-id="element-154" data-mp="28bmuhpii0637">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12" data-id="element-155" data-mp="24ajkvkr1n6af">
        <Reveal className="max-w-2xl" data-id="element-156" data-mp="248qco10s8e0b">
          <SectionLabel data-id="element-157" data-mp="1zbzu971i96bq">The House</SectionLabel>
          <h2 className="mt-6 font-serif text-[clamp(2rem,4.5vw,3.5rem)] font-light leading-[1.08] text-forest-deep" data-id="element-158" data-mp="1zaylxabvixxp">
            Your home in Taveuni
          </h2>
          <p className="mt-5 text-[16px] leading-relaxed text-forest-deep/65" data-id="element-159" data-mp="nw1phfdd16gb">
            Comfort, simplicity and everything you need to feel at home.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:mt-20 lg:grid-cols-4" data-id="element-160" data-mp="1vsnyhdcwqax3">
          {houseImages.map((image, i) => <Reveal key={image.src} delay={i % 4 * 0.06} className={i === 0 ? 'sm:col-span-2 lg:row-span-2' : ''} y={18} data-id="element-161" data-mp="1hrblnat1mpff" data-mpi={i}>
              <button type="button" onClick={() => setOpenIndex(i)} className="group relative block h-full w-full overflow-hidden rounded-[1.5rem] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-ivory" data-id="element-162" data-mp="181ihuvz57elq">
                <img src={image.src} alt={image.alt} loading="lazy" className={`w-full transition-transform duration-[1200ms] ease-calm group-hover:scale-[1.03] ${image.fit === 'contain' ? 'bg-sand-light object-contain' : 'object-cover'} ${i === 0 ? 'h-72 lg:h-full' : 'h-56 lg:h-[248px]'}`} data-id="element-163" data-mp="131e1r725clw1" />
                <span className="absolute inset-0 bg-forest-deep/0 transition-colors duration-500 group-hover:bg-forest-deep/15" data-id="element-164" data-mp="2n0peuohb8nvg" />
              </button>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} data-id="element-165" data-mp="3epsji5d4008m">
          <ul className="mt-14 grid gap-x-8 gap-y-8 border-t border-sand-dark/50 pt-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-166" data-mp="3eopxaaqqelz1">
            {amenities.map(amenity => {
            const Icon = amenityIcons[amenity.icon];
            return <li key={amenity.label} className="flex items-start gap-4" data-id="element-167" data-mp="30rkk7qslomua">
                  <Icon className="mt-0.5 h-5 w-5 flex-shrink-0 text-gold" strokeWidth={1.4} aria-hidden="true" data-id="element-168" data-mp="1uaz14gjlbnzv" />
                  <div data-id="element-169" data-mp="1pe8l1t7scseg">
                    <p className="flex flex-wrap items-center gap-2 text-[13px] font-semibold uppercase tracking-[0.13em] text-forest-deep" data-id="element-170" data-mp="1f8h5bb3zenot">
                      {amenity.label}
                      {amenity.highlight && <span className="rounded-full bg-gold/15 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-gold" data-id="element-171" data-mp="1p5d3oo061tfn">
                          {amenity.highlight}
                        </span>}
                    </p>
                    <p className="mt-1 text-[14px] text-forest-deep/55" data-id="element-172" data-mp="22x9tgled3r8v">
                      {amenity.note}
                    </p>
                  </div>
                </li>;
          })}
          </ul>
        </Reveal>

      </div>

      <Lightbox images={houseImages} index={openIndex} onClose={() => setOpenIndex(null)} onChange={setOpenIndex} data-id="element-173" data-mp="2cv7hp8w81o1h" />
    </section>;
}